import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Text } from 'src/components/Text';

interface Props {
  count: number;
  resource: ReactNode;
}

export const ResourceCount = ({ count, resource }: Props) => {
  if (count === 0) {
    return <div />;
  }

  return (
    <Text ariaLabel="resource_count" size="xs" color="grey" transform="uppercase">
      <FormattedMessage
        id="resource_count"
        defaultMessage="<b>{count}</b> {resource}"
        values={{
          b: (chunks) => <b>{chunks}</b>,
          resource,
          count,
        }}
      />
    </Text>
  );
};
